export enum DocumentSource {
    Upload = 'Upload',
    InboundFaxes = 'Inbound Faxes',
    Letter = 'Letter',
    Fax = 'Fax',
    Appeals ='Appeals'
}